import styled from '@emotion/styled';
import { Button, Typography } from '@material-ui/core';
import CheckCircle from '@material-ui/icons/CheckCircle';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { CreationDetailFragment } from '../../../generated/graphql';
import { useFinalizeCreation } from '../../../hooks/useFinalizeCreation';
import { SPACING_UNIT } from '../../constant/spacing';

interface Props extends ClassAttributes<HTMLElement> {
  creation: CreationDetailFragment;
  reload: () => void;
  className?: string;
}

const CompleteButton = ({ creation, reload, className }: Props) => {
  const { finalizeCreation } = useFinalizeCreation();

  return (
    <Root className={className}>
      <Button
        size="large"
        color="primary"
        variant="contained"
        disabled={creation.finalized}
        onClick={async () => {
          await finalizeCreation(creation.id);
          reload();
        }}
      >
        <CheckCircle />
        <ButtonText>
          {creation.finalized ? (
            <FormattedMessage id="reputation.completed" />
          ) : (
            <FormattedMessage id="reputation.title" />
          )}
        </ButtonText>
      </Button>
    </Root>
  );
};

const Root = styled('div')({
  display: 'inline-block',
  lineHeight: 1,
});

const ButtonText = styled(Typography)({
  marginLeft: SPACING_UNIT / 2,
  color: 'inherit',
});

export default CompleteButton;
